import React from 'react';
import { Button, Typography, Tooltip } from '@material-ui/core';
import history from 'services/history';
import useStyles from './styles';
import classnames from 'classnames';
import { useReduxSelector } from 'hooks';
import RegisteredTM from 'components/registeredTM';
import { getOrgDiv } from 'ducks/auth/selectors';
import { getBranding, isLpmRadioDetection } from 'whitelabel';
import { getUser } from 'ducks/auth/selectors';
import { rdExtra } from '../../config';

const FTitle = ({ branding }) => {
  return (
    <div onClick={null}
      style={{
        display: 'flex',
        alignItems: 'center',  // Vertical centering
        gap: '0.12rem',        // Optional spacing between elements
      }}>
      <span>{branding.footerTitle}</span>
      {branding.footerTitle && branding.footerTitle.trim() !== '' && (
        <RegisteredTM color={'#fff'} />
      )}
    </div>
  );
};

const FCopyright = ({ branding }) => {
  const copyright = <span>{branding.footerCopyright}</span>;

  return branding.footerSubtitle ? (
    <Tooltip title={branding.footerSubtitle} arrow>
      <span style={{ cursor: 'pointer' }}>
        {branding.footerCopyright}
      </span>
    </Tooltip>
  ) : (
    copyright
  );
};

const redirect = href => event => {
  event.preventDefault();
  history.push(href);
};

const links = [
  {
    label: 'Support',
    href: '/support',
    onClick: event => {
      event.preventDefault();
      const url = window.location.href;
      history.push('/support', { referred_from: url });
    }
  },
  {
    label: 'FAQs',
    href: 'https://utto.freshdesk.com/support/solutions',
    target: '_blank'
  }
];

const Footer = ({ classname, isLoginPage = false }) => {
  const classes = useStyles();
  const currentYear = new Date().getFullYear();
  const { org, div } = useReduxSelector(getOrgDiv);
  const user = useReduxSelector(getUser);

  const isLpmRadioDetectionDomain = isLpmRadioDetection() || org === 'RadioDetection';

  const branding = getBranding(org);

  // RadioDetection footer - solid light grey with content centered
  if (isLpmRadioDetectionDomain) {
    return (
      <div
        style={{
          backgroundColor: branding.footerBackgroundColor,
          height: '3.5rem',
          width: isLoginPage ? '100%' : 'calc(100% - 240px)', // Full width on login page
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          textAlign: 'center',
          padding: '0px 20px',
          position: 'fixed',
          bottom: 0,
          left: isLoginPage ? 0 : '240px', // No left offset on login page
          right: 0,
          zIndex: 1000
        }}
      >
        <div style={{
          textAlign: 'center',
          maxWidth: '75%',
          wordWrap: 'break-word'
        }}>
          <Typography
            variant="body2"
            style={{
              color: branding.footerTextColor,
              fontSize: branding.footerTextSize
            }}
          >
            Copyright © {currentYear} {branding.footerCopyright}
          </Typography>
          <Typography
            variant="body2"
            style={{
              color: branding.footerTextColor,
              fontSize: branding.footerTextSize
            }}
          >
            {branding.footerSubtitle}
          </Typography>
        </div>

        <Typography
          variant="body2"
          style={{
            color: branding.footerTextColor,
            fontSize: branding.footerTextSize,
            textAlign: 'center',
          }}
        >
          <Button
            color="inherit"
            href="/terms-rd"
            onClick={redirect('/terms-rd')}
            style={{
              color: '#0066cc',
              fontSize: branding.footerTextSize,
              textTransform: 'none',
              padding: '0 2px',
              minWidth: 'auto'
            }}
          >
            Terms of Use
          </Button>
          {' | '}

          <Button
            color="inherit"
            href={isLpmRadioDetectionDomain ? "/privacypolicy-rd" : "/privacypolicy"}
            onClick={redirect(isLpmRadioDetectionDomain ? "/privacypolicy-rd" : "/privacypolicy")}
            style={{
              color: '#0066cc',
              fontSize: branding.footerTextSize,
              textTransform: 'none',
              padding: 0,
              padding: '0 2px',
              minWidth: 'auto'
            }}
          >
            Data Privacy
          </Button>
        </Typography>
      </div>
    );
  }

  // Default footer for all other organizations
  return (
    <div className={classnames(classname, classes.foot)}>
      <div className={classes.links}>
        <Typography variant="button" color="inherit">
          © {currentYear} <FCopyright branding={branding} />
        </Typography>
        <Button color="inherit" href="/terms" onClick={redirect('/terms')}>
          Terms
        </Button>
        <Button
          color="inherit"
          href={isLpmRadioDetectionDomain ? "/privacypolicy-rd" : "/privacypolicy"}
          onClick={redirect(isLpmRadioDetectionDomain ? "/privacypolicy-rd" : "/privacypolicy")}
        >
          Privacy
        </Button>
      </div>
      <div>
        <Typography component="div" color='inherit' style={{ fontWeight: 'bold' }}>
          {< FTitle branding={branding} />}
        </Typography>
      </div>
      <div className={classes.links}>
        {links.map(({ href, label, onClick, target }) => (
          <Button key={label} color="inherit" href={href} target={target} onClick={onClick}>
            {label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default Footer;
